module.exports = __webpack_public_path__ + "img/hk_maru.211a39d1.png";